import "core-js/modules/es6.regexp.split";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import TransitionExpand from '~/components/templates/TransitionExpand.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';
import { searchFiltersLabels } from '~/const/listing/algolia';
export default {
  name: 'CategoryFiltersBar',
  components: {
    TransitionExpand
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: _objectSpread({}, mapMutations({
    filterBy: 'pageActions/FILTER_BY',
    resetFilters: 'pageActions/RESET_FILTERS'
  }), {
    removeFilter(tag) {
      this.filterBy({
        filter: tag.filter,
        facet: tag.facet
      });
    },

    reset() {
      this.$emit('on-reset-filters');
      this.resetFilters();
    },

    getTagLabel(activeFilter) {
      if (activeFilter.filter === 'more_info') return searchFiltersLabels[activeFilter.label] || activeFilter.label;
      return activeFilter.filter === 'price' ? this.formatCurrency(activeFilter.label) : activeFilter.label;
    },

    activeFilterLabel(activeFilter) {
      return ['depth', 'width', 'height'].includes(activeFilter.filter) ? "".concat(this.$t(activeFilter.filter), ": ").concat(this.getTagLabel(activeFilter)) : this.getTagLabel(activeFilter);
    },

    formatCurrency(value) {
      const prices = value.split('-');
      const formattedPrices = [];
      prices.forEach(price => {
        formattedPrices.push(new Intl.NumberFormat(this.locale.iso, {
          style: 'currency',
          currency: this.locale.currency,
          maximumSignificantDigits: 3
        }) // eslint-disable-next-line
        .format(price));
      });
      return formattedPrices.join(' - ');
    }

  })
};